import React, { useState } from 'react';
import { ElementForContentProperty } from '@bynder-studio/render-core';
import CreateModal from './components/modals/CreateModal';

export function useContentPropertyCreateModal({
    onCreate,
    elementName,
    selectedElements,
}: {
    onCreate: (name: string) => void;
    elementName: string;
    selectedElements: ElementForContentProperty[];
}) {
    const [isOpen, setIsModalOpen] = useState(false);

    const renderContentPropertyCreateModal = () => {
        return (
            <CreateModal
                elementName={elementName}
                isOpen={isOpen}
                onClose={() => setIsModalOpen(false)}
                onCreate={onCreate}
                selectedElements={selectedElements}
            />
        );
    };

    return {
        renderContentPropertyCreateModal,
        setIsContentPropertyCreateModalOpen: setIsModalOpen,
    };
}
